(function () {
  const CF_REGEX = /^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}[A-Za-z]$/;
  const PIVA_REGEX = /^[A-Za-z0-9]{4,20}$/;
  const SDI_REGEX = /^[A-Za-z0-9]{7}$/;
  const PEC_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const _registerCartFiscalData = () => {
    Alpine.data("xCartFiscalData", (initial) => ({
      tipoCliente: initial.tipoCliente || 'privato',
      codiceFiscale: initial.codiceFiscale || '',
      ragioneSociale: initial.ragioneSociale || '',
      partitaIva: initial.partitaIva || '',
      sedeItalia: !!initial.sedeItalia,
      sdi: initial.sdi || '',
      pec: initial.pec || '',
      countryIsIT: !!initial.countryIsIT,
      errors: {},
      _t: null,
      init() {
        this.$watch('tipoCliente', () => this.save());
        this.$watch('codiceFiscale', () => this.save());
        this.$watch('ragioneSociale', () => this.save());
        this.$watch('partitaIva', () => this.save());
        this.$watch('sedeItalia', () => this.save());
        this.$watch('sdi', () => this.save());
        this.$watch('pec', () => this.save());

        window.__cartFiscalDataValidate = () => this.validate();
      },
      get showSdiSection() {
        return this.tipoCliente === 'azienda' && this.sedeItalia;
      },
      validate() {
        this.errors = {};
        let ok = true;

        if (this.tipoCliente === 'privato') {
          if (!CF_REGEX.test((this.codiceFiscale || '').trim())) {
            this.errors.codiceFiscale = 'Codice Fiscale non valido';
            ok = false;
          }
        } else {
          if (!(this.ragioneSociale || '').trim()) {
            this.errors.ragioneSociale = 'Campo obbligatorio';
            ok = false;
          }
          const pivaClean = (this.partitaIva || '').replace(/[\s\-.]/g, '');
          if (!PIVA_REGEX.test(pivaClean)) {
            this.errors.partitaIva = 'Partita IVA / VAT number non valido';
            ok = false;
          }
        }

        if (this.showSdiSection) {
          if (!SDI_REGEX.test((this.sdi || '').trim())) {
            this.errors.sdi = 'Codice SDI obbligatorio (7 caratteri)';
            ok = false;
          }
          if (!PEC_REGEX.test((this.pec || '').trim())) {
            this.errors.pec = 'PEC obbligatoria e deve essere valida';
            ok = false;
          }
        }

        return ok;
      },
      handleBlur() {
        this.validate();
      },
      save() {
        clearTimeout(this._t);
        this._t = setTimeout(() => {
          const attrs = {
            'Tipo Cliente': this.tipoCliente === 'azienda' ? 'Azienda' : 'Privato',
            'Codice Fiscale': this.tipoCliente === 'privato' ? (this.codiceFiscale || '').trim().toUpperCase() : '',
            'Ragione Sociale': this.tipoCliente === 'azienda' ? (this.ragioneSociale || '').trim() : '',
            'Partita IVA': this.tipoCliente === 'azienda' ? (this.partitaIva || '').trim().toUpperCase() : '',
            'Codice SDI': this.showSdiSection ? (this.sdi || '').trim().toUpperCase() : '',
            'PEC': this.showSdiSection ? (this.pec || '').trim() : '',
          };
          if (window.xCartHelper && typeof window.xCartHelper.updateCart === 'function') {
            window.xCartHelper.updateCart({ attributes: attrs });
          } else if (window.Alpine && Alpine.store('xCartHelper') && typeof Alpine.store('xCartHelper').updateCart === 'function') {
            Alpine.store('xCartHelper').updateCart({ attributes: attrs });
          }
        }, 400);
      },
    }));
  };

  if (window.Alpine) {
    _registerCartFiscalData();
  } else {
    document.addEventListener("alpine:init", _registerCartFiscalData);
  }

  // ── Patch goToCheckout on BOTH possible cart-helper implementations ────
  // This theme currently ships two parallel systems that can both be active
  // on the same page: window.xCartHelper (assets/new-cart-helper.js, global,
  // loaded from theme.liquid) and Alpine.store('xCartHelper') (assets/cart.js,
  // loaded additionally by sections/main-cart.liquid on the cart page only).
  // Whichever the checkout button's @click actually references
  // ($store.xCartHelper.goToCheckout or window.xCartHelper.goToCheckout)
  // must be patched, so both are covered defensively.
  function _wrapGoToCheckout(obj) {
    if (!obj || typeof obj.goToCheckout !== 'function' || obj.__fiscalDataPatched) return false;
    const _original = obj.goToCheckout.bind(obj);
    obj.goToCheckout = function (e) {
      const onCartPage = window.location.pathname.indexOf('/cart') !== -1;

      // Checkout triggered from the drawer (or anywhere off /cart): always
      // route through the cart page first, so the customer fills in the
      // fiscal data there instead of skipping straight to Shopify checkout.
      if (!onCartPage) {
        if (e && e.preventDefault) e.preventDefault();
        window.location.href = '/cart';
        return;
      }

      if (typeof window.__cartFiscalDataValidate === 'function' && !window.__cartFiscalDataValidate()) {
        if (e && e.preventDefault) e.preventDefault();
        const fiscalCard = document.getElementById('CartFiscalData');
        if (fiscalCard) {
          fiscalCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      return _original(e);
    };
    obj.__fiscalDataPatched = true;
    return true;
  }

  function _patchAll() {
    _wrapGoToCheckout(window.xCartHelper);
    if (window.Alpine && typeof Alpine.store === 'function') {
      try {
        _wrapGoToCheckout(Alpine.store('xCartHelper'));
      } catch (err) {
        // store not registered yet
      }
    }
  }

  _patchAll();
  document.addEventListener('alpine:initialized', _patchAll);
  document.addEventListener('DOMContentLoaded', _patchAll);
  window.addEventListener('load', _patchAll);
  setTimeout(_patchAll, 300);
  setTimeout(_patchAll, 800);
  setTimeout(_patchAll, 1500);
  setTimeout(_patchAll, 3000);
})();
